var map = {
	"./0.png": 120,
	"./1.png": 121,
	"./2.png": 122,
	"./3.png": 123,
	"./4.png": 124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 555;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eg ^\.\/.*\.png$
// module id = 555
// module chunks = 2